import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';

import { searchSchema } from './-schema';

export const Route = createFileRoute(
  '/_staff/supplier/_list/settings/supplier-subcategories/',
)({
  validateSearch: zodValidator(searchSchema),
});
